import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

const TestPrint = () => {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    
    
  });


  return (
    <div>
      
      <div
        ref={componentRef}
        style={{
          padding: "20px",
          border: "1px solid black",
          maxWidth: "600px",
          margin: "20px auto",
        }}
      >
        <h1 className="bg-white text-center">Test Print Content</h1>
        <p className="bg-white">This content will be printed.</p>
      </div>
      <button
        className="bg-white border border-black px-4 py-2"
        onClick={handlePrint}
      >
        Print
      </button>
    </div>
  );
};

export default TestPrint;